import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'
import { ButtonOutlined, ButtonContained } from '../app-button/button'
import Row from '../profile/Row'
import Spinner from '../spinner'
import { Visa, MasterCard } from '../app-icon/Icons'
import Switch from '@material-ui/core/Switch'
import { withSnackbar } from 'notistack'

const styles = theme => ({
  cardBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 140,
    height: 88,
    padding: 10,
    borderRadius: 8,
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: '#ffcc00',
  },
  cardBoxDisabled: {
    backgroundColor: '#fff',
  },
  cardBoxNotActive: {
    backgroundColor: '#fff',
    border: 'solid 1px #bbbbbb',
    borderStyle: 'dashed',
  },
  cardBoxError: {
    backgroundColor: '#fff',
    border: 'solid 1px #ff4e44',
  },
  cardPan: {
    fontSize: 16,
    color: '#000000',
  },
  cardActions: {
    marginLeft: 28,
  },
  cardBtn: {
    width: 160,
    height: 40,
    marginBottom: 8,
    padding: 0,
    fontSize: 16,
    color: '#000000',
    border: 'solid 1px #bbbbbb',
  },
  cardType: {
    display: 'none',
  },
  cardInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  cardBroadcaster: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardBroadcasterStatus: {
    fontSize: 10,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#000000',
    textTransform: 'uppercase',
    '& span': {
      display: 'block',
    },
  },
  switch: {
    marginLeft: '-10px',
  },
  switchBase: {
    '&$switchChecked': {
      '& + $switchBar': {
        backgroundColor: '#ffcc00',
        border: '1px solid #000',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  switchBar: {
    borderRadius: 13,
    width: 40,
    height: 24,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: `${theme.palette.grey[50]}`,
    opacity: '1 !important',
    transition: theme.transitions.create(['background-color', 'border']),
  },
  switchIcon: {
    width: 16,
    height: 16,
    marginTop: '-2px',
    backgroundColor: '#bbbbbb',
    boxShadow: 'none',
  },
  switchIconChecked: {
    backgroundColor: '#000',
  },
  switchChecked: {
    transform: 'translateX(15px)',
    '& + $switchBar': {
      opacity: 1,
      border: 'none',
    },
  },
  addCardBtn: {
    width: 160,
    height: 40,
    padding: 0,
    fontSize: 16,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000000',
  },
  cardMessageError: {
    display: 'block',
    fontSize: 14,
    textAlign: 'center',
    color: 'rgb(255, 78, 68)',
    textTransform: 'uppercase',
  },
  cardActionsDescription: {
    fontSize: 12,
    marginBottom: 0,
    lineHeight: 1.2,
  },
})

class PaymentCard extends Component {
  state = {
    load: false,
    card: window.state.card || this.props.card,
    autoPayToggleUrl: window.state.card && window.state.card.autoPayToggleUrl,
    cardAddUrl: window.state.cardAddUrl,
    checked: window.state.card && window.state.card.autoPay,
    openConfirmPopup: false,
    editCard: false,
    lastPayment: window.state.lastPayment,
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked })
    const url = `${this.state.autoPayToggleUrl}`

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const handleServerError = message => {
      this.setState({
        isFetching: false,
      })

      if (message.errors && message.status == 422) {
        this.setState({
          errors: message.errors,
        })
      } else {
        const error = `Произошла ошибка на сервере (${message.status}).
        Попробуйте снова или обратитесь в поддержку.`

        this.props.enqueueSnackbar(error, {
          variant: 'error',
          preventDuplicate: true,
          autoHideDuration: 6000,
        })
      }
    }

    function handleResponse(response) {
      return response.json().then(json => {
        if (response.ok) {
          return json
        } else {
          let error = Object.assign({}, json, {
            status: response.status,
            statusText: response.statusText,
          })

          return Promise.reject(error)
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(({ autoPay, autoPayToggleUrl }) => {
        this.setState(
          {
            checked: autoPay,
            autoPayToggleUrl: autoPayToggleUrl,
          },
          () => {
            this.props.response.getAutoPay(autoPay)
          }
        )
      })
      .catch(message => handleServerError(message))
  }

  handleDeleteCard = () => {
    this.setState(
      {
        openConfirmPopup: true,
      },
      () => {
        this.props.response.getStatusCard(this.state.openConfirmPopup)
      }
    )
  }

  handleEditCard = () => {
    this.setState(
      {
        openConfirmPopup: true,
        editCard: true,
      },
      () => {
        this.props.response.getStatusCard(this.state.openConfirmPopup)
        this.props.response.editCard(this.state.editCard)
      }
    )
  }

  handleAddCard = () => {
    this.setState({
      load: true,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.card !== this.props.card) {
      this.setState({
        card: this.props.card,
      })
    }
  }

  render() {
    const { checked, card, lastPayment } = this.state
    const { classes } = this.props

    const pan = card && this.props.card && (
      <span className={classes.cardPan}>{this.state.card.pan}</span>
    )

    const icons = card && this.props.card && (
      <span className={classes.cardType}>
        <Visa width={23.3} height={8.4} />
        <MasterCard width={19} height={18} />
      </span>
    )

    const broadCaster = card && this.props.card && (
      <div className={classes.cardBroadcaster}>
        <Switch
          checked={checked}
          onChange={this.handleChange('checked')}
          value="checked"
          classes={{
            root: classes.switch,
            switchBase: classes.switchBase,
            bar: classes.switchBar,
            icon: classes.switchIcon,
            iconChecked: classes.switchIconChecked,
            checked: classes.switchChecked,
            disabled: classes.customDisabled,
          }}
        />
        <div className={classes.cardBroadcasterStatus}>
          <span>
            {checked ? `автоплатеж\n включен` : `включить\n автоплатеж`}
          </span>
        </div>
      </div>
    )

    const cardBox = (
      <div
        className={cx(classes.cardBox, {
          [classes.cardBoxDisabled]: !checked,
          [classes.cardBoxNotActive]: !card || !this.props.card,
          [classes.cardBoxError]: lastPayment && !lastPayment.status && card,
        })}
      >
        <div className={classes.cardInfo}>
          {pan}
          {icons}
        </div>
        {lastPayment && !lastPayment.status && card ? (
          <span className={classes.cardMessageError}>ошибка платежа</span>
        ) : (
          card && !checked && broadCaster
        )}
      </div>
    )

    const btns = this.props.card ? (
      <Fragment>
        <ButtonOutlined
          handleClick={this.handleEditCard}
          className={classes.cardBtn}
          color="secondary"
          text="Изменить карту"
        />

        {card && !checked ? (
          <ButtonOutlined
            handleClick={this.handleDeleteCard}
            className={classes.cardBtn}
            color="secondary"
            text="Отвязать карту"
          />
        ) : null}
      </Fragment>
    ) : (
      <Fragment>
        <ButtonContained
          onClick={this.handleAddCard}
          customClass={classes.addCardBtn}
          color="primary"
          href={window.state.cardAddUrl}
          text={
            this.state.load ? (
              <Spinner stroke={'#000000'} width={16} height={16} />
            ) : (
              'Добавить карту'
            )
          }
        />
        <p className={classes.cardActionsDescription}>
          Для привязки карты мы спишем и вернем 1 рубль.
        </p>
      </Fragment>
    )

    const cardActions = <div className={classes.cardActions}>{btns}</div>

    return <Row left={cardBox} right={cardActions} />
  }
}

export default withStyles(styles)(withSnackbar(PaymentCard))
